import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    savedTimers: [],
};

const timerReducer = createSlice({
    name: 'timerReducer',
    initialState,
    reducers: {
        appendToSavedTimers(state, action) {
            if(!state.savedTimers) state.savedTimers = []
            state.savedTimers = [...state.savedTimers,action.payload]
        },
        setSavedTimers(state, action) {
            if(!state.savedTimers) state.savedTimers = []
            state.savedTimers = action.payload
        },
        setUpdateSavedTimer(state, action) {
            const {_id} = action.payload
            const indexToUpdate = state.savedTimers.findIndex(savedTimer => savedTimer._id == _id)
            state.savedTimers[indexToUpdate] = action.payload
        },

        clear(state) {
            state.form = initialState.form;
        },
    },
});

export const {
    clear: clearTimeReducerForm,
    appendToSavedTimers,
    setSavedTimers,
    setUpdateSavedTimer
} = timerReducer.actions;
export default timerReducer.reducer;
